import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";
import { useEffect } from 'react';
import Hero from "../components/Hero";
import contactBg from '../assets/images/contact.jpg';

function Contact() {
  useEffect(() => {
    document.title = "DCode | Contact us";
  }, []);
  return (
    <>



      <Hero bgimg={contactBg} content="Please fill free to to email contact@designite-tools.com or fill out the form below." title="Get in touch" />
      <div className="container contact-cnt">
        <div className="row">
          <div className="col-md-1 col-12 col-sm-12 col-lg-1"></div>
          <div className="col-md-10 col-12 col-sm-12 col-lg-10">
            <ContactForm />
          </div>
          <div className="col-md-1 col-12 col-sm-12 col-lg-1"></div>
        </div>
      </div>
      <div className="container contact-cnt">
        <div className="row">
          <div className="col-md-1 col-12 col-sm-12 col-lg-1"></div>
          <div className="col-md-10 col-12 col-sm-12 col-lg-10">
            <h3>Technical and sales</h3>
            <p>
              For technical, as well as sales queries please contact us at{" "}
              <a href="mailto:contact@designite-tools.com">
                contact@designite-tools.com
              </a>
              .
            </p>
            <p>
              <strong>Address</strong>
              <br />
              Designite Software Solutions
              <br />
              20 Caudle park crescent,
              <br />
              Lower Sackville,
              <br />
              Nova Scotia, Canada. B4C1Z2.
              <br />
            </p>
          </div>
          <div className="col-md-1 col-12 col-sm-12 col-lg-1"></div>
        </div>
      </div>
      <Footer />

    </>
  );
}

export default Contact;
